module.exports = __webpack_public_path__ + "img/schreiberloaves-banner.a6a07756.jpg";